import { stateDistricts } from '../../data/stateDistricts';
import { chapters } from '../../data/341Chapters';
import {
  NoticeType,
  TabHeader,
  formDataTypes,
  formDataErrors,
  PDFFile,
  SignatureBlocksErrors,
  ReturnAddressErrors,
  BankruptcyClerkErrors,
  JobCreationResponse,
} from '../../utils/constant';

const defaultErrors = {
  mailingType: '',
  directMailingType: '',
  plaintiff: '',
  defendant: '',
  estatePartyName: '',
  courtState: '',
  courtDistrict: '',
  courtDivision: '',
  caseNumber: '',
  caseSource: '',
  adversaryProceeding: {
    isChecked: false,
    adversaryNumber: '',
    serviceParties: [],
    adversaryPlaintiff: '',
    adversaryDefendant: '',
  },
  courtJurisdiction: '',
  combinedParties: '',
  caseDocket: '',
  uploadedPdfs: [],
  address: '',
  preferences: '',
  signatureBlocks: '',
  caseChapter: '',
  debtorName: '',
  caseChapterFillingDate: '',
  caseConvertedChapter: '',
  caseConvertedDate: '',
  bankruptcyType: '',
  meetingDate: '',
  meetingTime: '',
  meetingLocation: '',
  caseDocketEntries: [],
  ssnOrItin: '',
  ein: '',
  bankruptcyClerk: '',
  dischargeable: '',
  creditorsProofOfClaim: '',
  governmentProofOfClaim: '',
  debtDischarge: '',
  deadlineForFillingProofOfClaim: '',
  fillingPlanSelected: '',
  hearingDate: '',
  hearingTime: '',
  hearingLocation: '',
  hearingInformation: '',
  customFileName: '',
  deadlineProofOfClaimSelected: '',
  deadlineForFillingProofOfClaimSpecial: '',
  rules: '',
  edcaCaseProceeding: '',
  edcaServedParty: '',
  serviceCapacity: '',
  userUploadedAddresses: '',
  attestationType: '',
  directClientName: '',
  secondaryClientName: '',
  paymentMethodId: '',
};

const defaultFormData: formDataTypes = {
  mailingType: '',
  isECFUnavailable: false,
  directMailingType: null,
  legalCaseFields: {
    plaintiff: '',
    defendant: '',
    estatePartyName: '',
  },
  courtState: '',
  courtDistrict: '',
  courtDivision: '',
  caseNumber: { textfieldValue: '', value: '' },
  jointCaseNumbers: [],
  multipleCaseNumbersToChoose: {},
  caseSource: {
    userSupplied: false,
    masterMailingMatrix: false,
    importCaseParties: false,
  },
  courtJurisdiction: {
    county: '',
    state: '',
    division: '',
  },
  adversaryProceeding: {
    isChecked: false,
    adversaryNumber: '',
    serviceParties: [],
    adversaryPlaintiff: '',
    adversaryDefendant: '',
  },
  hasMultipleCasesToChoose: false,
  caseNumbers: [],
  caseDocket: '',
  uploadedPdfs: [],
  uploadedProofOfClaim: [],
  uploadedBallot: [],
  personalizedNumberOfPages: '1',
  caseParties: [],
  creditors: [],
  attorneys: [],
  orderPreferences: {
    sides: 'double_sided',
    format: '1up',
    inkColor: 'black_and_white',
    service: 'Normal',
    blankPage: '',
  },
  caseDocketEntries: [],
  selectedCaseDocketEntries: [],
  caseData: {},
  returnAddresses: [],
  signatureBlocks: [],
  certificatePreferences: {
    shouldAddHearingInfo: false,
    shouldAttachDocs: false,
    shouldIncludeNEF: false,
    shouldIncludeCustomName: false,
    customFileName: '',
    hearingInformation: {
      hearingDate: '',
      hearingTime: '',
      hearingLocation: '',
      responseDate: '',
    },
  },
  caseChapter: '',
  caseChapterFillingDate: '',
  caseConvertedChapter: '',
  caseConvertedDate: '',
  bankruptcyType: '',
  proofOfClaim: '',
  subChapterV: '',
  meetingDate: '',
  meetingTime: '',
  meetingLocation: '',
  debtorAttorney: null,
  debtors: [],
  debtorTrustee: null,
  bankruptcyClerk: {
    fullName: 'Tonislav Tachev',
    addressOne: '9532 Ocean View Drive',
    addressTwo: 'Suite 4',
    city: 'Lost Angeles',
    state: 'California',
    zipCode: '1000',
    phone: '0896760717',
    email: 'tachevvt@gmail.com',
    fax: '458961',
    webAddress: 'https://www.google.com',
    workingHours: '09:00 - 17:00',
  },
  presumptionOfAbuse: '',
  dischargeable: '',
  creditorsProofOfClaim: '',
  governmentProofOfClaim: '',
  debtDischarge: '',
  deadlineForFillingProofOfClaim: '',
  fillingPlanSelected: '',
  deadlineProofOfClaimSelected: '',
  deadlineForFillingProofOfClaimSpecial: '',
  optionalDeadlineForFilingComplaint: '',
  judgeName: '',
  newJerseyAttestation: {
    attestationType: '',
    directClientName: '',
    secondaryClientName: '',
  },
  edcaServedParty: {
    debtor: false,
    plaintiff: false,
    defendant: false,
    allCommitteeMembers: false,
    equitySecurityHolders: false,
    allCreditorsAndPartiesInInterestNoticeOfHearingOnly: false,
    onlyCreditorsThatHaveFiledClaimsNoticeOfHearingOnly: false,
    allCreditorsAndPartiesInInterest: false,
    fewerThanAllCreditors: {
      creditorsThatHaveFiledClaims: false,
      creditorsHoldingAllowedSecuredClaims: false,
      creditorsHoldingAllowedPriorityUnsecuredClaims: false,
      creditorsHoldingLeasesOrExecutoryContractsThatHaveBeenAssumed: false,
      twentyLargestCreditors: false,
    },
    administrativeClaimants: false,
    otherPartyInInterest: false,
    isFewerThanAllCreditorsChecked: false,
  },
  californiaServiceDelivery: {},
  edcaCaseProceeding: [],
  docketControlNumber: '',
  edcaChapter7ECFNumber: '',
  edcaChapter9ECFNumber: '',
  edcaChapter12or13ECFNumber: '',
  edcaChapter11ECFNumber: '',
  serviceCapacity: {},
  rule7004: {},
  rule5: {},
  userUploadedAddresses: [],
  userUploadedAddressFiles: 0,
  includeReturnEnvelope: false,
  returnEnvelope: {
    name: '',
    office: '',
    address: '',
    city: '',
    state: '',
    zipCode: '',
    isPostageIncluded: false,
  },
  hasLoadedDefaultCourt: false,
  isLoadingUploadedAddresses: false,
  includeCertificateOfService: null,
  barRuleDisclosure: '',
  clientCategory: '',
  paymentMethodId: '',
  isCaseNumberChecked: false,
  isBarInfoChecked: false,
  temporaryCasePartiesStatus: [],
  rawCaseNumbers: [],
};

const defaultSignatureErrors = {
  fullName: '',
  barNumber: '',
  firmName: '',
  clientRole: '',
  addressOne: '',
  city: '',
  state: '',
  zipCode: '',
  phone: '',
  email: '',
  country: '',
  fax: '',
};

const defaultReturnAddressErrors = {
  addressName: '',
  firmName: '',
  addressOne: '',
  city: '',
  state: '',
  zipCode: '',
};

const defaultBankruptcyClerkErrors = {
  fullName: '',
  addressOne: '',
  city: '',
  state: '',
  zipCode: '',
  phone: '',
  email: '',
  fax: '',
  webAddress: '',
  workingHours: '',
  addressTwo: '',
};

const jobCreationResponse = {
  caseNumbers: [''],
  debtorName: '',
  trackingNumber: '',
  ipAddress: '',
};

interface UploadTypes {
  noticeType: NoticeType;
  tabs: TabHeader[];
  courtStates: string[] | undefined;
  courtDistricts: string[] | undefined;
  caseChapters: string[] | undefined;
  formData: formDataTypes;
  errors: formDataErrors;
  focusedFile: PDFFile | null;
  totalUploadedPdfsPageSize: number;
  totalUploadedPdfsFileSize: number;
  submitJobError: string;
  hasFetchedCase: boolean;
  requiredToChooseCaseNumber: boolean;
  fetchingOnlyCaseParties: boolean;
  fetchingOnlyCreditors: boolean;
  caseInfoState: {
    message: string;
    status: 'pending' | 'success' | 'error';
  } | null;
  hasLoadedUserSettings: boolean;
  signatureBlocksErrors: SignatureBlocksErrors;
  returnAddressErrors: ReturnAddressErrors;
  bankruptcyClerkErrors: BankruptcyClerkErrors;
  isCreatingNotice: { status: 'pending' | 'success' | 'error' } | null;
  jobCreationResponse: JobCreationResponse;
  returnAddrStatus: {
    status: 'pending' | 'success' | 'error';
    message: string;
  } | null;
  certificateStatus: {
    status: 'pending' | 'success' | 'error';
    message: string;
  } | null;
  hasFechedReturnAddresses: boolean;
  hasFetchedSignatures: boolean;
  uploadAddressesError: string;
  availableServiceOptions: {
    isNormalServiceEnabled: boolean;
    isRushServiceEnabled: boolean;
  };
  /**
   * When set, AddressPage will open the edit drawer for the user-uploaded address
   * with this id. Set by BkNoticeFormButtons when a user clicks an address in
   * the invalid-addresses alert triggered from the Continue button.
   * Cleared by AddressPage after consuming.
   */
  pendingEditAddressId: string | null;
}

export const initialState: UploadTypes = {
  isCreatingNotice: null,
  noticeType: { type: 'notice-bk' },
  tabs: [],
  courtStates: Object.keys(stateDistricts),
  caseChapters: chapters,
  courtDistricts: [],
  focusedFile: null,
  totalUploadedPdfsPageSize: 0,
  totalUploadedPdfsFileSize: 0,
  hasFetchedCase: false,
  requiredToChooseCaseNumber: false,
  fetchingOnlyCaseParties: false,
  fetchingOnlyCreditors: false,
  caseInfoState: null,
  formData: defaultFormData,
  submitJobError: '',
  errors: defaultErrors,
  signatureBlocksErrors: defaultSignatureErrors,
  returnAddressErrors: defaultReturnAddressErrors,
  bankruptcyClerkErrors: defaultBankruptcyClerkErrors,
  hasLoadedUserSettings: false,
  jobCreationResponse,
  returnAddrStatus: null,
  certificateStatus: null,
  hasFechedReturnAddresses: false,
  hasFetchedSignatures: false,
  uploadAddressesError: '',
  availableServiceOptions: {
    isNormalServiceEnabled: true,
    isRushServiceEnabled: true,
  },
  pendingEditAddressId: null,
};
